export const SIDEBAR = [
  {
    id: 1,
    path: "/home",
    name: "HOME",
  },
  {
    id: 2,
    path: "/services",
    name: "SERVICES",
  },
  {
    id: 3,
    path: "/portfolio",
    name: "PORTFOLIO",
  },
  {
    id: 4,
    path: "/about",
    name: "ABOUT",
  },
  {
    id: 5,
    path: "/contact",
    name: "CONTACT",
  },
];
